import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Instagram } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-navy-900 text-slate-300 py-12 border-t border-navy-800" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12" data-id="element-145">
          <div data-id="element-146">
            <div className="flex items-center gap-2 mb-6" data-id="element-147">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-white flex items-center justify-center shrink-0" data-id="element-148">
                <img src="https://cdn.magicpatterns.com/uploads/7kvJW8m3bLhnmJS1ZmPMSn/WhatsApp_Image_2026-06-09_at_09.43.25.jpg" alt="Logo Depilación Láser Uruguay" className="w-full h-full object-cover" data-id="element-149" />
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-150">
                Depilación Láser
              </span>
            </div>
            <p className="text-slate-400 mb-6" data-id="element-151">
              Especialistas en depilación láser definitiva con tecnología
              Soprano en Montevideo.
            </p>
            <motion.a href="https://instagram.com/depilacion.laseruruguay" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(58,107,165,0)', '0 0 18px 2px rgba(58,107,165,0.55)', '0 0 0 0 rgba(58,107,165,0)']
          }} transition={{
            duration: 2.4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center gap-2 text-white font-semibold bg-brand-600 hover:bg-brand-500 px-4 py-2 rounded-full transition-colors" data-id="element-152">
              <Instagram className="w-5 h-5" data-id="element-153" />
              <span data-id="element-154">@depilacion.laseruruguay</span>
            </motion.a>
          </div>

          <div data-id="element-155">
            <h4 className="text-white font-bold mb-6 flex items-center gap-2" data-id="element-156">
              <MapPin className="w-5 h-5 text-brand-500" data-id="element-157" />
              Ubicación
            </h4>
            <p className="text-slate-400 mb-4" data-id="element-158">
              Avda. Uruguay 1788
              <br data-id="element-159" />
              Cordón, Montevideo
              <br data-id="element-160" />
              Uruguay
            </p>

            <a href="https://www.google.com/maps/search/?api=1&query=Avda.+Uruguay+1788,+Cordón,+Montevideo" target="_blank" rel="noopener noreferrer" className="group block relative w-full max-w-xs rounded-xl overflow-hidden border border-navy-800 hover:border-brand-500 transition-colors" aria-label="Abrir ubicación en Google Maps" data-id="element-161">
              <iframe title="Mapa de la ubicación" src="https://maps.google.com/maps?q=Avda.%20Uruguay%201788,%20Cord%C3%B3n,%20Montevideo&z=16&output=embed" className="w-full h-32 pointer-events-none grayscale-[20%]" loading="lazy" data-id="element-162" />
              <span className="absolute inset-0 bg-navy-900/0 group-hover:bg-navy-900/20 transition-colors" data-id="element-163" />
              <span className="absolute bottom-2 right-2 inline-flex items-center gap-1 bg-brand-600 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-md" data-id="element-164">
                <MapPin className="w-3.5 h-3.5" data-id="element-165" />
                Cómo llegar
              </span>
            </a>
          </div>

          <div data-id="element-166">
            <h4 className="text-white font-bold mb-6 flex items-center gap-2" data-id="element-167">
              <Clock className="w-5 h-5 text-brand-500" data-id="element-168" />
              Horarios de atención
            </h4>
            <ul className="space-y-2 text-slate-400" data-id="element-169">
              <li className="flex justify-between" data-id="element-170">
                <span data-id="element-171">Lunes a Viernes</span>
                <span data-id="element-172">13:30 - 23:00</span>
              </li>
              <li className="flex justify-between" data-id="element-173">
                <span data-id="element-174">Sábados</span>
                <span data-id="element-175">07:00 - 16:00</span>
              </li>
              <li className="flex justify-between text-slate-500" data-id="element-176">
                <span data-id="element-177">Domingos</span>
                <span data-id="element-178">Cerrado</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-navy-800 text-center text-[11px] sm:text-sm text-slate-500 space-y-1.5 px-2 max-w-md mx-auto leading-relaxed" data-id="element-179">
          <p data-id="element-180">
            © {new Date().getFullYear()} Depilación Láser Uruguay. Todos los
            derechos reservados.
          </p>
          <p data-id="element-181">Esta web fue creada por WebsiteIA</p>
        </div>
      </div>
    </footer>;
};